var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C9.78771 8 8 9.78772 8 12C8 14.2123 9.78771 16 12 16C14.2123 16 16 14.2123 16 12C16 9.78772 14.2123 8 12 8ZM10 12C10 10.8923 10.8923 10 12 10C13.1077 10 14 10.8923 14 12C14 13.1077 13.1077 14 12 14C10.8923 14 10 13.1077 10 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM12 17.5C8.13541 17.5 4.78877 15.2615 3.18488 12C4.78877 8.73854 8.13541 6.5 12 6.5C15.8646 6.5 19.2112 8.73854 20.8151 12C19.2112 15.2615 15.8646 17.5 12 17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.d9e5ffd8cc3639cb4d67bf6a3e1ec1d6.svg";
export { ForwardRef as ReactComponent };